import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ImmortalFruitsParsedInitData} from "../../server/data/ImmortalFruitsParsedInitData";
import {ImmortalFruitsSoundConfig} from "../../ImmortalFruitsSoundConfig";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GambleEvents} from "@nolimitcity/slot-gamble/bin/config/GambleEvents";
import {IGambleSoundConfig} from "@nolimitcity/slot-gamble/bin/NoLimitGamblePlugin";

export class SoundManager {
    private static currentLoop: string = "";
    private _shouldPlayBonusBG: boolean = false;
    private _isBonus: boolean = false;

    private static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    constructor() {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onReady());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, "onGameStart", () => this.onGameStart());

        NolimitApplication.events.on(GambleEvents.GAMBLE_PLAY_EFFECT_SOUND, (data: IGambleSoundConfig) => this.playGambleEffectSound(data));
        NolimitApplication.events.on(GambleEvents.GAMBLE_PLAY_KEYPAD_SOUND, (data: IGambleSoundConfig) => this.playGambleKeypadSound(data));
        NolimitApplication.events.on(GambleEvents.GAMBLE_STOP_EFFECT_SOUND, (data: IGambleSoundConfig) => this.stopGambleEffectSound(data));
    }
    private onInitDataParsed(data: ImmortalFruitsParsedInitData) {
        this._isBonus = data.mode === ImmortalFruitsGameMode.BONUS_WHEEL;
        this._shouldPlayBonusBG = this._isBonus && data.nextMode === ImmortalFruitsGameMode.BONUS_WHEEL;
    }

    private onGameStart() {
        if (this._shouldPlayBonusBG) {
           // SoundManager.playBonusBG();
        }
    }

    private onReady() {
        if (this._isBonus) {
            SoundManager.playAmbientLoop(ImmortalFruitsSoundConfig.instance.MAIN_GAME_AMBIANCE_1, undefined, 0);
            if (this._shouldPlayBonusBG) {
                SoundManager.playBonusBG();
            }
            //SoundManager.playSound(ImmortalFruitsSoundConfig.instance.MEDIUM_AND_LARGE_WIN, undefined, 0);
        } else {
            SoundManager.playAmbientLoop(ImmortalFruitsSoundConfig.instance.MAIN_GAME_AMBIANCE_1);
            //SoundManager.playSound(ImmortalFruitsSoundConfig.instance.MEDIUM_AND_LARGE_WIN, undefined, 0);
        }

    }

    public static playAmbientLoop(name: string, duration: number = 0, volume: number = 1): void {
        this.currentLoop = name;
        this.soundPlayer.playTrack({
            name: this.currentLoop
        });

        this.soundPlayer.fadeTrack({
            name:this.currentLoop,
            to:volume,
            duration:duration
        })

    }

    public static playSound(name: string, repeat?: number, volume?: number): void {
        this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume
        })
    }

    public static stopSound(name: string, fadeOutDuration?: number): void {
        this.stopSoundEffect(name, fadeOutDuration);
    }

    public static fadeInMainBGSound(duration: number): void {
        this.currentLoop = ImmortalFruitsSoundConfig.instance.MAIN_GAME_AMBIANCE_1;
        this.soundPlayer.fadeTrack({
            name: ImmortalFruitsSoundConfig.instance.MAIN_GAME_AMBIANCE_1,
            duration: duration,
            to: 1
        });
    }

    public static fadeOutMainBGSound(duration: number): void {
        //Logger.log("sound fadeOutMainBGSound", duration);
        this.soundPlayer.fadeTrack({
            name: ImmortalFruitsSoundConfig.instance.MAIN_GAME_AMBIANCE_1,
            duration: duration,
            to: 0
        });
    }

    public static fadeSound(name: string, duration: number, to: number, from?: number): void {
        this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            from: from,
            to: to
        });
    }

    public static playMediumAndLargeWinSound(): void {
        // //Logger.log("mediumAndLargeWin playMediumAndLargeWinSound");
        // this.soundPlayer.fadeTrack({
        //     name: ImmortalFruitsSoundConfig.instance.MEDIUM_AND_LARGE_WIN,
        //     to: 1,
        //     duration: 200
        // });
        // if (SoundManager.mediumLargeWinTimeOut) {
        //     clearTimeout(SoundManager.mediumLargeWinTimeOut);
        // }
        // SoundManager.mediumLargeWinTimeOut = setTimeout(this.fadeMediumAndLargeWinSound.bind(this), 15000);
    }

    public static fadeMediumAndLargeWinSound(): void {
        //Logger.log("mediumAndLargeWin fadeMediumAndLargeWinSound");
        this.soundPlayer.fadeTrack({
            name: ImmortalFruitsSoundConfig.instance.MEDIUM_AND_LARGE_WIN,
            to: 0,
            duration: 10000
        });
    }

    public static reset(): void {
        //SoundManager.fadeSound(ImmortalFruitsSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 300, 1);
        //SoundManager.fadeSound(ImmortalFruitsSoundConfig.instance.MEDIUM_AND_LARGE_WIN, 300, 0);
    }

    public static playBonusIntroWheel() {
        //Logger.log("playBonusIntroWheel");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BONUS_INTRO_WHEEL);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUS_INTRO_WHEEL, 0, 1);
    }

    public static playBonusIntroLogo() {
        //Logger.log("sound playBonusIntroLogo");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BONUS_INTRO_LOGO);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUS_INTRO_LOGO, 0, 1);
    }

    public static playReelLanding(reelId: number) {
        //Logger.log("sound playReelLanding", reelId);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.REELS_DEFAULT_BOUNCE[reelId]);
    }

    public static playReelSpinning(randomNum: number) {
        //Logger.log("sound playReelSpinning", randomNum);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.REELS_SPIN[randomNum], Infinity, 1);
    }

    public static stopReelSpinning() {
        //Logger.log("sound stopReelSpinning");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.REELS_SPIN[0]);
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.REELS_SPIN[1]);
    }

    public static playSpinStart(index : number) {
        //Logger.log("sound playSpinStart ", index);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.SPIN_START_SOUNDS[index]);
    }

    public static playScatter(scatterCounter: number) {
        //Logger.log("sound playScatter", scatterCounter);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.SCATTER + scatterCounter);
    }

    public static playAnticipation() {
        //Logger.log("sound playAnticipation");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.ANTICIPATION);
    }

    public static playAnticipationFail() {
        //Logger.log("sound playAnticipationFail");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.ANTICIPATION_FAILS);
    }

    public static stopAnticipation() {
        //Logger.log("sound stopAnticipation");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.ANTICIPATION);
    }

    public static playBonusBG() {
        //Logger.log("sound playBonusBG");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BACKGROUND_MUSIC_BONUS);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BACKGROUND_MUSIC_BONUS, undefined, 1);
    }

    public static fadeOutBonusBG(duration: number) {
        //Logger.log("sound fadeOutBonusBG", duration);
        SoundManager.fadeSound(ImmortalFruitsSoundConfig.instance.BACKGROUND_MUSIC_BONUS, duration, 0);
    }


    public static playContinueBtn() {
        //Logger.log("sound playContinueBtn");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BW_CONTINUE_BTN);
    }

    public static playBigWinInitial() {
        //Logger.log("sound playBigWinInitial");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BIG_WIN_INITIAL_WIN);
    }

    public static playBigWinCountUp() {
        //Logger.log("sound playBigWinCountUp");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BIG_WIN_COUNT_UP, Infinity, 1);
    }

    public static stopBigWinCountUp() {
        //Logger.log("sound stopBigWinCountUp");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BIG_WIN_COUNT_UP);
    }

    public static playBigWin() {
        //Logger.log("sound playBigWin");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BIG_WIN);
    }

    public static stopBigWin() {
        //Logger.log("sound stopBigWin");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BIG_WIN);
    }

    public static playBigWinLevel(level: number) {
        //Logger.log("sound playBigWinLevel", level);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BIG_WIN_LEVEL + (level + 1));
    }

    public static stopBigWinLevel(level: number) {
        //Logger.log("sound stopBigWinLevel", level);
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BIG_WIN_LEVEL + (level + 1));
    }

    public static playBigWinEnds() {
        //Logger.log("sound playBigWinEnds");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BIG_WIN_ENDS);
    }

    public static playCountUpEnds() {
        //Logger.log("sound playCountUpEnds");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.COUNT_UP_ENDS);
    }
    public static playKeypadSound(name: string): void {
        this.soundPlayer.playKeypadSound(name);
    }
    public static playCountUp() {
        //Logger.log("sound playCountUp");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.COUNT_UP, Infinity, 1);
    }

    public static stopCountUp() {
        //Logger.log("sound stopCountUp");
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.COUNT_UP);
    }

    public static playWildLanding() {
        //Logger.log("sound playWildLanding");
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.WILD_LANDING);
    }
    private playGambleEffectSound(config: IGambleSoundConfig): void {
        let repeat: number = 0;
        if (config.loop) {
            repeat = Infinity;
            SoundManager.fadeAmbienceLoop(0, 100);
        }
        SoundManager.playSoundEffect(config.name, repeat);

        //SoundManager.playSoundEffect(config.name);

    }

    private playGambleKeypadSound(config: IGambleSoundConfig): void {
        SoundManager.playKeypadSound(config.name);
    }

    // Please NOTE the duration is in millisecond!
    public static fadeAmbienceLoop(volume: number, duration: number): void {
        this.soundPlayer.fadeTrack({
            name: this.currentLoop,
            duration: duration,
            to: volume
        });
    }


    private stopGambleEffectSound(config: IGambleSoundConfig): void {
        if (config.loop) {
            SoundManager.fadeAmbienceLoop(1, 100);
        }

        SoundManager.stopSoundEffect(config.name, config.fadeOutDuration);
    }
    public static playSoundEffect(name: string, repeat?: number, volume?: number): void {
        this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume,
        })
    }

    private static fadeAndStop(name: string, duration:number, to:number, from?:number){
        this.soundPlayer.fadeTrack({
            name: name,
            from:from,
            to: to,
            duration: duration
        });

        setTimeout(()=>{
            this.soundPlayer.stopTrack(name);
        }, duration)

    }

    public static stopSoundEffect(name: string, fadeOutDuration?: number): void {
        if (fadeOutDuration && fadeOutDuration > 0){
            this.fadeAndStop(name, fadeOutDuration, 0)
        } else  {
            this.soundPlayer.stopTrack(name);
        }
    }
}